<template>
<!--  <page-banner :pageNumber="6" />-->
  <crumbs />
  <div class="mainContainer">
    <show-content :detail="detail" />
    <recommended-news :recommendedList="recommendedNewsList" />
  </div>
</template>

<script setup>
import {getDetailsOnPartyAndMassBuilding, getGWRecommendedPartyBuilding} from "../../../apis/dqjs";
const Route = useRoute()
const partyBuildingId = ref(Route.params.partyBuildingId)

let detail = ref({})
let Res = await useAsyncData('getDetailsOnPartyAndMassBuilding',
    () => getDetailsOnPartyAndMassBuilding({partyBuildingId: partyBuildingId.value}),
)
if (Res.data.value.code !== 200) {
  throw createError({statusCode: Res.data.value.code, statusMessage: encodeURIComponent("getDetailsOnPartyAndMassBuilding")})
} else {
  detail.value = Res.data.value.data
}

let recommendedNewsList = ref([])
let recommendedRes = await useAsyncData('getGWRecommendedPartyBuilding', () => getGWRecommendedPartyBuilding({partyBuildingId: partyBuildingId.value}))
if (recommendedRes.data.value.code !== 200) {
  throw createError({statusCode: recommendedRes.data.value.code, statusMessage: encodeURIComponent("recommendedRes")})
} else {
  recommendedNewsList.value = recommendedRes.data.value.data
}
</script>

<style scoped lang="scss">
.mainContainer{
  display: flex;
  align-items: flex-start;
}
</style>